// Phase 3b (QA P0) — axios' err.message on a validation 400 is a generic "Request failed with
// status code 400"; the real message lives in err.response.data.errors (array) per the backend's
// validateDateRange/validateEmailStatus/validateWindowDays contract.
export const getApiErrorMessage = (err, fallback) => {
  const errors = err && err.response && err.response.data && err.response.data.errors;
  if (Array.isArray(errors) && errors.length > 0) {
    return errors.join(' ');
  }
  const message = err && err.response && err.response.data && err.response.data.message;
  if (message) return message;
  return (err && err.message) || fallback;
};

export default getApiErrorMessage;
